import { createSlice } from "@reduxjs/toolkit";

const guestSlice = createSlice({
  name: "guest",
  initialState: {
    bookingId: null,
    guestName: null,
    bID: null,
  },
  reducers: {
    setBookingId: (state, action) => {
      state.bookingId = action.payload;
    },
    setGuestName: (state, action) => {
      state.guestName = action.payload;
    },
    setbID: (state, action) => {
      state.bID = action.payload;
    },
  },
});

export const { setBookingId, setGuestName, setbID } = guestSlice.actions;
export default guestSlice.reducer;
